import { EntityType } from './entity';

export enum CustomFieldType {
    CLASSIFIER = 'CLASSIFIER',
    DATE = 'DATE',
    DECIMAL = 'DECIMAL',
    EMPLOYEE = 'EMPLOYEE',
    HEADER = 'HEADER',
    INTEGER = 'INTEGER',
    TEXTAREA = 'TEXTAREA',
    TEXTINPUT = 'TEXTINPUT',
    BOOLEAN = 'BOOLEAN',
}

type BaseCustomField = {
    id: number;
    label: string | null;
    description: string | null;
    orderNum: number;
    isMandatory: boolean;
    // RELATIONSHIP_TYPE codes `isMandatory` is limited to. Empty or absent means it holds for every
    // relationship type, which is how every field outside the party entity types behaves.
    mandatoryRelationshipTypeCodes?: string[];
    entityType?: EntityType;
    shouldTranslate: boolean;
    showCopyIcon: boolean;
    apiFieldName: string;
};

export type CustomField = BaseCustomField &
    (
        | {
              isMultivalue: true;
              values: unknown[];
          }
        | {
              isMultivalue: false;
              value: unknown;
          }
    ) &
    (
        | { fieldType: CustomFieldType.CLASSIFIER; classifierCode: string }
        | { fieldType: Exclude<CustomFieldType, CustomFieldType.CLASSIFIER> }
    );

export type SectionedCustomField = { id: number; section: string; fields: CustomField[]; shouldTranslate: boolean };

type BaseCustomFieldDto = {
    id: number;
    isMandatory: boolean;
    fieldType: CustomFieldType;
};

export type CustomFieldDto = BaseCustomFieldDto &
    (
        | {
              isMultivalue: true;
              values: unknown[];
          }
        | {
              isMultivalue: false;
              value: unknown;
          }
    );

export type CustomFieldValue = {
    customFieldId: number;
    value: unknown;
};
